import { render, staticRenderFns } from "./LandingPlansTable.vue?vue&type=template&id=23c5a352&scoped=true"
import script from "./LandingPlansTable.vue?vue&type=script&lang=js"
export * from "./LandingPlansTable.vue?vue&type=script&lang=js"
import style0 from "./LandingPlansTable.vue?vue&type=style&index=0&id=23c5a352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5a352",
  null
  
)

export default component.exports